<!-- js/components/Admin/ProjectView.vue -->

<template>
    <section class="project" v-if="project.id">
      <Breadcrumb
          v-if="this.fromRelatedProject"
          :to="{name: 'projects.show', params: { projectId: this.fromRelatedProject.id }}"
          :title="this.fromRelatedProject.title"
      />
      <Breadcrumb
          v-if="this.previousSearchParams"
          :to="{name: 'projects', query: this.previousSearchParams}"
          title="Search"
      />
      <div class="flex flex-col lg:flex-row lg:justify-between lg:mb-4 space-y-2 lg:space-y-0">
            <div class="flex-grow">
                <h2 class="text-2xl text-cal-009588">{{ project.title }}</h2>
            </div>
            <div class="flex-shrink print:hidden">
              <div class="flex flex-col lg:flex-row lg:items-center space-y-1 lg:space-y-0 lg:space-x-2">
                <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" @click="requestResearch">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13.67" height="13.67" viewBox="0 0 13.67 13.67">
                    <path id="Icon_material-message" data-name="Icon material-message" d="M15.3,3H4.367a1.365,1.365,0,0,0-1.36,1.367L3,16.67l2.734-2.734H15.3a1.371,1.371,0,0,0,1.367-1.367v-8.2A1.371,1.371,0,0,0,15.3,3Zm-1.367,8.2h-8.2V9.835h8.2Zm0-2.05h-8.2V7.784h8.2Zm0-2.05h-8.2V5.734h8.2Z" transform="translate(-3 -3)" fill="#888"/>
                  </svg>
                  <span class="text-xs">Request Research</span>
                </button>
                <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" v-if="$root.$data.auth.user.allowShare" @click="share">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15.387" height="13.677" viewBox="0 0 15.387 13.677">
                    <path id="Icon_awesome-share-square" data-name="Icon awesome-share-square" d="M15.186,4.74,11.339,8.373a.642.642,0,0,1-1.081-.466V5.984c-3.862.026-5.491.938-4.4,4.577a.428.428,0,0,1-.668.463,5.142,5.142,0,0,1-1.983-3.83c0-3.845,3.141-4.608,7.052-4.63V.641A.642.642,0,0,1,11.339.175l3.847,3.633A.641.641,0,0,1,15.186,4.74Zm-4.928,5.387v1.84H1.71V3.419H3.07a.32.32,0,0,0,.231-.1A5.208,5.208,0,0,1,4.664,2.314a.32.32,0,0,0-.148-.6H1.282A1.282,1.282,0,0,0,0,2.992v9.4a1.282,1.282,0,0,0,1.282,1.282h9.4a1.282,1.282,0,0,0,1.282-1.282V10.023a.32.32,0,0,0-.428-.3,1.919,1.919,0,0,1-.913.09A.321.321,0,0,0,10.258,10.128Z" fill="#888"/>
                  </svg>
                  <span class="text-xs">Email project</span>
                </button>
                <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" @click="addNote">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.326" height="12.326" viewBox="0 0 12.326 12.326">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(0 -2.25)" fill="#888"/>
                  </svg>
                  <span class="text-xs">{{ noteButtonLabel }}</span>
                </button>
                <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" @click="print">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13.554" height="12.199" viewBox="0 0 13.554 12.199">
                    <path id="Icon_material-print" data-name="Icon material-print" d="M14.521,7.889H5.033A2.03,2.03,0,0,0,3,9.922v4.066H5.711V16.7h8.132V13.988h2.711V9.922A2.03,2.03,0,0,0,14.521,7.889Zm-2.033,7.455H7.066V11.955h5.422ZM14.521,10.6a.678.678,0,1,1,.678-.678A.68.68,0,0,1,14.521,10.6Zm-.678-6.1H5.711V7.211h8.132Z" transform="translate(-3 -4.5)" fill="#888"/>
                  </svg>
                  <span class="text-xs">Print</span>
                </button>
                <button class="text-sm text-bold py-1 px-2 uppercase bg-white border border-gray-200 text-cal-888888 inline-flex items-center space-x-2" v-if="project.user && project.user.id" @click="remove">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15.431" height="15.431" viewBox="0 0 17.431 17.431">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(10.306 -1.591) rotate(45)" fill="#888"/>
                  </svg>
                  <span class="text-xs">Remove</span>
                </button>
                <button class="text-sm text-bold py-1 px-2 uppercase bg-cal-81B920 text-white inline-flex items-center space-x-2" v-else @click="add">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.326" height="12.326" viewBox="0 0 12.326 12.326">
                    <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M11.445,7.092H7.483V3.13a.881.881,0,0,0-.88-.88h-.88a.881.881,0,0,0-.88.88V7.092H.88a.881.881,0,0,0-.88.88v.88a.881.881,0,0,0,.88.88H4.842V13.7a.881.881,0,0,0,.88.88H6.6a.881.881,0,0,0,.88-.88V9.733h3.962a.881.881,0,0,0,.88-.88v-.88A.881.881,0,0,0,11.445,7.092Z" transform="translate(0 -2.25)" fill="#fff"/>
                  </svg>
                  <span class="text-xs">Add Saved Projects</span>
                </button>
              </div>
            </div>
        </div>

        <div class="flex items-center justify-center border-t border-cal-E8E8E8 py-2.5">
            <div class="flex-grow">
              <div class="text-sm">
                <div>Project ID: {{ project.id }}</div>
                <div>Date Entered: {{ utcToLocal(project.created_at) }}</div>
              </div>
            </div>
            <div class="flex-shrink" v-if="project.user && project.user.id">
                <status-block
                    :current-status="project.user.tag_id"
                    :options="tags"
                    v-on:selected-status="onSelectStatus">Folder</status-block>
            </div>
        </div>
      <div class="mb-4"></div>

      <div class="bg-white p-2 mb-4" v-if="notes.length > 0">
        <note-block v-on:note-deleted="getNotes" :edit="editNote" :note="notes[0]"></note-block>
        <details class="mt-4" :open="false" v-if="notes.length > 1">
          <summary class="uppercase font-bold cursor-pointer text-sm">Older notes</summary>
          <note-block class="mt-4" v-on:note-deleted="getNotes" v-for="item in notes.slice(1)" :note="item" :edit="editNote" :key="item.id"></note-block>
        </details>
      </div>

        <vue-tabs>
            <div class="tab" title="Overview">
                <h3 class="mobile-only">Overview</h3>
              <div class="grid grid-cols-2 gap-4">
                  <div class="divide-y divide-cal-EBEBEB project-details">
                    <detail-item label="Estimated Value">{{ project.minimum_value }}M</detail-item>
                    <detail-item label="Sector">{{ project.sector }}</detail-item>
                    <detail-item label="Project Type">{{ projectType }}</detail-item>
                    <detail-item label="Project Subtype" v-if="projectSubtype">{{ projectSubtype }}</detail-item>
                    <detail-item label="Project Brand" v-if="projectBrand">{{ projectBrand }}</detail-item>
                    <detail-item :label="`Project ${projectUnitsLabel}`" v-if="showProjectUnits && projectUnits">{{ projectUnits }}</detail-item>
                    <detail-item label="Construction Type">{{ constructionType }}</detail-item>
                    <detail-item label="Projected Stage" v-if="project.stage">{{ project.stage.name }}</detail-item>
                    <detail-item label="Address">{{ address }}</detail-item>
                    <detail-item label="Details">{{ project.details }}</detail-item>
                    <detail-item label="Is demolition?" v-if="project.is_demolition">{{ project.is_demolition }}</detail-item>
                    <!-- <detail-item label="General contractor selected?" v-if="project.gc_selected">{{ project.gc_selected }}</detail-item> -->
                    <detail-item label="Negotiated work" v-if="project.negotiated_work">{{ negotiatedWork }}</detail-item>
                    <detail-item label="Est. Start Date">
                      <div v-if="project.start_date">{{ utcToLocal(project.start_date) }}</div>
                      <div v-else>{{ formatEstimatedDate(project.start_date_notes) }}</div>
                    </detail-item>
                    <detail-item label="Est. End Date">
                      <div v-if="project.end_date">{{ utcToLocal(project.end_date) }}</div>
                      <div v-else-if="project.end_date_notes">{{ formatEstimatedDate(project.end_date_notes) }}</div>
                    </detail-item>
                    </div>
                    <div class="column project-map-column">
                        <google-map :center="center" :zoom="16" class="project-map">
                            <map-marker :position="center" :clickable="false"></map-marker>
                        </google-map>
                    </div>
              </div>
            </div>

            <div class="tab" title="Bidding Information" v-if="hasBiddingInformation()">
              <div class="project-bidding-information">
                    <span class="bidding-information-date" v-if="project.bidding_date">
                        Bid Date: {{ project.bidding_date | moment("MM/DD/YYYY") }}
                    </span><br/><br/>
                <span v-if="project.bidding_information">
                        {{ project.bidding_information }}
                    </span>
                <span v-else>
                        No bidding information at this time.
                    </span>
              </div>
            </div>

            <div class="tab" title="Updates">
                <div class="project-update-notes" :class="{'hidden': !legacyUpdateNote}" v-html="legacyUpdateNote"></div>
                <div class="project-updates" v-if="!legacyUpdateNote">
                    <vue-table
                        :columns="updateTable.columns"
                        :column-titles="updateTable.columnTitles"
                        :rows="project.updates"
                        :total-rows="updateTable.totalRows">
                        <div slot="empty">No Associated Updates</div>
                    </vue-table>
                </div>
            </div>

            <div class="tab" title="Materials">
                <h3 class="mobile-only">Materials</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4">
                <span v-for="material in project.materials">{{ material.name }}</span>
                <p v-if="project.materials && project.materials.length <= 0">No materials listed</p>
              </div>
            </div>


            <div class="tab project-contacts" title="Contacts">
                <h3 class="mobile-only">Contacts</h3>
                <div class="project-contacts">
                    <vue-table
                        :columns="contactTable.columns"
                        :column-titles="contactTable.columnTitles"
                        :rows="project.contacts"
                        :total-rows="contactTable.totalRows"
                        v-on:selected-row="onSelectContactRow">
                        <div slot="empty">No Associated Contacts</div>
                    </vue-table>
                </div>
            </div>

        </vue-tabs>

        <div class="similar-projects mt-4 bg-white">
          <h3 class="text-xl p-4 mt-4">Similar Projects</h3>
            <vue-table
                :columns="similarTable.columns"
                :rows="similarTable.rows"
                :per-page="similarTable.params.perPage"
                v-on:selected-row="onSelectProjectRow">
            </vue-table>
        </div>

      <vue-modal
          v-if="showNoteModal"
          size="large"
          @close="showNoteModal = false">
        <div slot="header">
          <h3 v-if="!note">Add Note</h3>
          <h3 v-else>Edit Note</h3>
        </div>
        <div slot="body">
          <form class="my-2 space-y-6" @submit.prevent="saveNote">
            <div class="note-notification">
              <form-label is-for="notification-date">Enter reminder/follow-up date</form-label>
              <vue-pikaday
                  id="notification-date"
                  placeholder="Date"
                  v-model="note.notification_date"
              >
              </vue-pikaday>
            </div>
            <div>
              <form-label is-for="note">Note</form-label>
              <textarea
                  id="note"
                  class="block w-full sm:text-sm border border-gray-300 p-2 mt-2"
                  v-model="note.note">
                </textarea>
            </div>
            <primary-button v-if="!note.id">Save</primary-button>
            <primary-button v-if="note.id">Update</primary-button>
            <button class="text-sm text-bold py-1 px-2 uppercase bg-white text-cal-888888 inline-flex items-center space-x-2 mb-4" v-if="note.id" @click="cancelNoteEditing" >Cancel</button>
          </form>
          <div class="note-notification">
          </div>
        </div>
        <div slot="footer">
        </div>
      </vue-modal>

        <vue-modal
            v-if="showRequestModal"
            @close="showRequestModal = false">
            <div slot="header">
              <div class="text-right">
                <h3>Request Research</h3>
              </div>
            </div>
            <div slot="body">
              <form class="my-2 space-y-6" @submit.prevent="saveRequest">
                <div>
                  <form-label is-for="request_comment">Comment</form-label>
                  <textarea
                      class="block w-full sm:text-sm border border-gray-300 p-2 mt-2"
                      v-model="request.comment"
                      placeholder="What would you like us to investigate?">
                </textarea>
                </div>
                <primary-button>Submit Request</primary-button>
              </form>
            </div>
            <div slot="footer">
            </div>
        </vue-modal>
    </section>
</template>

<script>

import VueTable from '../Shared/VueTable.vue';
import ColumnView from '../Shared/ColumnView.vue';
import VueButton from '../Shared/VueButton.vue';
import VueModal from '../Shared/VueModal.vue';
import VueTabs from '../Shared/VueTabs.vue';
import VuePikaday from '../Shared/VuePikaday.vue';
import StatusBlock from '../Shared/StatusBlock.vue';
import NoteBlock from '../Shared/NoteBlock.vue';
import WebServices from '../../services/WebServices';
import Format from '../../mixins/Format';
import moment from 'moment';
import {Marker,Map} from 'vue2-google-maps';
import DetailItem from "../Shared/DetailItem.vue";
import PrimaryButton from "../Form/PrimaryButton";
import FormLabel from "../Form/FormLabel";
import Breadcrumb from "../Shared/Breadcrumb.vue";

export default {

  mixins: [Format],
  components: {
    VueTable,
    VueButton,
    VueModal,
    StatusBlock,
    NoteBlock,
    ColumnView,
    VueTabs,
    DetailItem,
    PrimaryButton,
    FormLabel,
    VuePikaday,
    GoogleMap: Map,
    MapMarker: Marker,
    Breadcrumb
  },

  data() {
    return {
      center: {lat: 10.0, lng: 10.0},
      projectServices: WebServices("Projects"),
      project: {
        id: 0,
        status: 0,
        stage: {},
        bidding_date: null,
        bidding_information: null,
        updates: [],
        negotiated_work: ''
      },
      notes: [],
      request: {
        comment: ""
      },
      showNoteModal: false,
      note: {
        id: null,
        note: null,
        notification_date: null
      },
      showRequestModal: false,
      showProjectUnits: false,
      projectUnitsLabel: 'Units',
      projectUnits: 0,
      hasLoadedMap: false,
      contactTable: {
        columns: {
          first_name: {
            title: "First Name"
          },
          last_name: {
            title: "Last Name"
          },
          title: {
            title: "Title"
          },
          company_name: {
            title: "Company"
          },
          company_type: {
            title: "Company Type",
            transform: function (value) {
              if (value) {
                return value["name"];
              }
              return "–";
            }
          },
          email: {
            title: "Email"
          },
          phone: {
            title: "Phone",
            transform: function (value) {
              return this.phone(value);
            }.bind(this)
          }
        },
      },
      updateTable: {
        columns: {
          updated_at: {
            title: "Updated At",
            transform: function (value) {
              return moment(String(value)).format('MM/DD/YYYY hh:mm A');
            }
          },
          message: {
            title: "Message",
            transform: function (value) {
              return value.replace(/\r\n|\r|\n/g, '<br />');
            }
          }
        },
        totalRows: 0
      },
      similarTable: {
        columns: {
          title: {
            title: "Name"
          },
          city: {
            title: "City"
          },
          state: {
            title: "State"
          },
          types: {
            title: "Project Type",
            sortable: false,
            transform: function (value) {
              return value.map(function (itm) {
                return itm.name
              }).join(", ")
            }
          },
          construction_type: {
            title: "Const Type"
          },
          stage: {
            title: "Project Stage",
            transform: function (value) {
              return value.name
            }
          },
          minimum_value: {
            title: "Value",
            transform: function (value) {
              return value + "M"
            }
          },
          created_at: {
            title: "Entered",
            transform: function (value) {
              return this.utcToLocal(value, "MM/DD/YY")
            }.bind(this)
          },
          updated_at: {
            title: "Updated",
            transform: function (value) {
              return this.utcToLocal(value, "MM/DD/YY")
            }.bind(this)
          }
        },
        rows: [],
        params: {
          page: 1,
          perPage: 5
        },
        totalRows: 0
      },
      tags: this.$root.$data.auth.user.projectTags,
      previousSearchParams: null,
      fromRelatedProject: null,
    }
  },

    computed: {
        noteButtonLabel () {
            return "Add Note";
        },

        projectType () {
            if (this.project.types == null) return "";
            return this.project.types.map(function(item) { return item.name }).join(", ");
        },

        projectSubtype () {
            if (this.project.subtypes == null) return "";
            return this.project.subtypes.map(function(item) { return item.name }).join(", ");
        },

        projectBrand () {
            if (this.project.brands == null) return "";
            return this.project.brands.map(function(item) { return item.name }).join(", ");
        },

        address() {
            var str = "";
            if (this.project.address1) { str += this.project.address1; }
            str += "\n";
            if (this.project.address2) { str += this.project.address2; }
            str += "\n";
            if (this.project.city) { str += this.project.city + ", "; }
            if (this.project.state) { str += this.project.state + " "; }
            if (this.project.zip) { str += this.project.zip; }
            return str.trim();
        },

        legacyUpdateNote() {
          return this.project.update_notes ? this.project.update_notes.replace(/\r\n|\r|\n/g, '<br />') : '';
        },

        constructionType() {
            if (this.project.renovation_includes_addition) {
                return this.project.construction_type + ' with addition';
            }
            return this.project.construction_type;
        },
      negotiatedWork() {
        if (this.project.negotiated_work === 'Bidding') {
          return 'No'
        }
        return this.project.negotiated_work;
      }
    },

    created () {
        this.hasLoadedMap = false;

		this.$gmapApiPromiseLazy({}).then(() => {
			if (this.address) {
				this.geocodeProject();
			}

            this.hasLoadedMap = true;
		});

        this.loadInitial();
    },

    methods: {

        hasBiddingInformation() {
          return (
              this.project.bidding_date !== null && this.project.bidding_date.length > 0
          ) || (
              this.project.bidding_information !== null && this.project.bidding_information.length > 0
          );
        },

        loadInitial () {
            this.project.id = this.$route.params.projectId;
            this.get();
            this.getSimilar();
        },

      get() {

        this.projectServices
            .getOne(this.project.id)
            .then((response) => {

              this.project = response.data.data;

              if (!this.project.user) {
                this.project.user = {
                  tag_id: null
                };
              }

              this.contactTable.totalRows = this.project.contacts.length;
              this.updateTable.totalRows = this.project.updates.length;

              if (this.project.max_unit || this.project.min_unit) {
                this.showProjectUnits = true;
                this.projectUnitsLabel = this.project.types[0]?.units_label || 'Units'
                this.projectUnits = Math.max(parseInt(this.project.min_unit || 0), parseInt(this.project.max_unit || 0))
              }

              // Reload and check remaining projects for free trial users.
              this.$root.$data.auth.decrementRemainingProjects();
              if (this.hasLoadedMap) {
                this.geocodeProject();
              }
            }, () => {
              swal({
                title: "Error",
                text: "A project with this ID could not be found. Please try searching for it instead.",
                type: "error",
                confirmButtonColor: "#40B572"
              }, function () {
                this.$router.push({name: "projects"});
                swal.close();
              }.bind(this));
            });
        this.getNotes()
      },
      getNotes() {
        this.projectServices
            .get({}, `${this.project.id}/Notes`)
            .then(res => {
              this.notes = res.data.data;
            })
      },

        getSimilar () {

            this.projectServices
            .getAll({}, this.project.id + '/Similar')
            .then((response) => {

                this.similarTable.rows = response.data.data
            }, () => {

            });
        },

        add () {

            this.projectServices
                .store({ project_id: this.project.id }, "Save")
                .then(function() {
                    this.get();
                }.bind(this));
        },

        remove () {

            this.projectServices
                .remove(this.project.id)
                .then(function() {
                    this.get();
                }.bind(this));
        },

        share () {

            var subject = this.project.title + " - Construct-A-Lead";
            var body = "";

            body += "Name: "+ this.project.title;
            body += "\nValue: "+ + this.project.minimum_value;
            body += "\nSector: "+ (this.project.sector || "–");
            body += "\nProject Schedule: "+ (this.project.stage.name || "–");
            body += "\nConstruction Type: "+ (this.project.construction_type || "–");
            body += "\nBidding Date: "+ (this.project.bidding_date || "–");
            body += "\nBidding Information: "+ (this.project.bidding_information || "–");
            body += "\nStart Date: "+ (this.project.start_date || "–");
            body += "\nStart Date Notes: "+ (this.formatEstimatedDate(this.project.start_date_notes) || "–");
            body += "\nEnd Date: "+ (this.project.end_date || "–");
            body += "\nEnd Date Notes: "+ (this.formatEstimatedDate(this.project.end_date_notes) || "–");
            body += "\nAddress: "+ (this.project.address1 || "–");
            body += "\nAddress2: "+ (this.project.address2 || "–");
            body += "\nCity: "+ (this.project.city || "–");
            body += "\nState: "+ (this.project.state || "–");
            body += "\nZip: "+ (this.project.zip || "–");
            body += "\nProject Details: "+ (this.project.details || "–");
            body += "\nProject Types";
            body += "\nMaterials List";
            body += "\n\nContacts:\n\n";
            for (var contact of this.project.contacts) {
                body += "Name: "+ contact.first_name;
                body += "\nValue: "+ contact.last_name;
                body += "\nCompany: "+ (contact.company || "–");
                if (contact.company_type) {
                    body += "\nCompany Type: "+ contact.company_type.name;
                }
                body += "\nEmail: "+ (contact.email || "–");
                body += "\nWebsite: "+ (contact.url || "–");
                body += "\nPhone Number: "+ (contact.phone || "–");
                body += "\nPhone Number 2: "+ (contact.phone2 || "–");
                body += "\nPhone Number 3: "+ (contact.phone3 || "–");
                body += "\nFax Number: "+ (contact.fax || "–");
                body += "\n\n"
            }

            var a = document.createElement('a');

            a.href = 'mailto: ?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
            a.setAttribute('style', 'display:none');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

      formatEstimatedDate (value) {
        const quarterValues = [
          'q1',
          'q2',
          'q3',
          'q4',
          'q1q2',
          'q2q3',
          'q3q4',
          'q4q1',
        ];
        if (value && value.indexOf('-') !== -1) {
          const [quarter, year] = value.split('-')
          if (quarterValues.includes(quarter.toLowerCase())) {
            return  quarter.toUpperCase() + ', ' + year;
          } else {
            return value
          }
        }
        return value;
      },

        print() {
            window.print();
        },

        requestResearch () {
            this.showRequestModal = true
        },

        addNote () {
            this.showNoteModal = true
        },

      saveNote() {
        this.projectServices
            .store(this.note, `${this.project.id}/Notes`)
            .then(function (response) {
              const data = response.data;
              if (data.error) {
                swal({
                  title: "Error",
                  text: response.data.message,
                  type: "error",
                  confirmButtonColor: "#40B572",
                  timer: 2500
                }, function () {
                  swal.close();
                });
                return
              }

              this.showNoteModal = false;
              this.get();
            }.bind(this), function (err) {
              console.log(err)
              swal({
                title: "Error",
                text: 'error',
                type: "error",
                confirmButtonColor: "#40B572",
                timer: 2500
              }, function () {
                swal.close();
              });
            });
      },

        saveRequest () {

            var services = WebServices("Messages");
            services.store({
                    project_id: this.project.id,
                    project_name: this.project.title,
                    comment: this.request.comment
                })
                .then(function() {
                    this.showRequestModal = false;
                    this.request.comment = {};
                    this.get();
                }.bind(this));
        },

        geocodeProject () {
          this.geocodeAddress(this.address);
        },

        geocodeAddress (address) {
          this.$http.get(`/api/frontend/V1/Geocode/${encodeURIComponent(address)}`)
              .then(response => {
                const {results, status} = response.body;
                if (status === 'OK') {
                  this.center = results[0].geometry.location
                } else {
                  console.log('Geocode was not successful for the following reason: ' + status);
                }
              })
              .catch((err) => {
                console.error(err)
              });
        },

      onSelectContactRow(row) {
        this.$router.push({
          name: 'contacts.show',
          params: {
            contactId: row.id,
            // @todo check if this is set and say "back to project
            relatedProject: {
              id: this.project.id,
              title: this.project.title,
            },
            row: row
          }
        });
      },

      onSelectProjectRow(row) {
        this.$router.push({
          name: 'projects.show',
          params: {
            projectId: row.id,
            // @todo check if this is set and say "back to project
            relatedProject: {
              id: this.project.id,
              title: this.project.title,
            },
            row: row
          }
        });
      },

        onSelectStatus (status) {

            var tag_id = status.id;
            if (this.project.user) {

                if (this.project.user.tag_id == tag_id) {
                    tag_id = null;
                }

                this.project.user.tag_id = tag_id;
            }

            this.projectServices
                .store({
                    project_id: this.project.id,
                    tag_id: tag_id
                }, "AddTag")
                .then(function() {
                    this.get();
                }.bind(this));
        },

        editNote (note) {
            this.showNoteModal = true;
            this.note = note;
        },
        cancelNoteEditing () {
            this.showNoteModal = false;
        }
    },

  beforeRouteEnter(to, from, next) {
    if (to.params.searchParams) {
      next(vm => {
        vm.previousSearchParams = to.params.searchParams
      });
    }
    else { next(); }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.relatedProject) {
      this.fromRelatedProject = to.params.relatedProject
    } else {
      this.fromRelatedProject = null;
    }
    next()
  },

    watch: {
        '$root.$data.auth.user': {
            handler: function () {
                this.tags = this.$root.$data.auth.user.projectTags;
            },
            deep: true
        },
        '$route': function () {
            this.loadInitial();
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
      showNoteModal: function(val) {
          if (val === false) {
            this.note = {
              id: null,
              value: null,
              notification_date: null
            }
          }
      }
    },
}


</script>

<style>
.project-map-column {
    min-width: 50%;
}

@media screen and (max-width: 480px) {
    .project-map-column {
        display: none;
    }
}

.project-map,
.vue-map {
    min-height: 400px;
    height: 100%;
}

.project-materials-list {
    display: flex;
    padding: 15px 20px;
    font-size: 14px;
    color: #4A4A4A;
    letter-spacing: 0;
    line-height: 24px;
}

.project-materials-list p {
    margin: 0;
    padding: 0;
}

.project-materials-list span {
    display: inline-block;
    flex-grow: 1;
    line-height: 24px;
    width: 33%;
}

@media screen and (max-width: 480px) {
    .project-materials-list span {
        width: 100%;
        word-break: break-word;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        margin-bottom: 2rem;
        border-bottom: 1px solid #e8e8e8;
    }
}

.project-bidding-information,
.project-update-notes {
    padding: 15px 20px;
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 14px;
    color: #4A4A4A;
    letter-spacing: 0;
    line-height: 24px;
}

.project .mobile-only {
    display: none;
}

@media screen and (max-width: 480px) {
    .project .mobile-only {
        display: block;
    }
}

@media print {
    .project .mobile-only {
        display: block;
    }
}

.project h2.mobile-only {
    font-weight: 500;
    font-size: 17px;
    color: #4A4A4A;
}

.project h3.mobile-only {
    font-weight: 500;
    font-size: 16px;
    color: var(--primary-color1);
    padding-bottom: 10px;
    border-bottom: 1px solid #E8E8E8;
}

.tabs-wrapper .tabs-nav {
    border: 0 !important;
}

.tabs-nav li:last-child {
    margin-right: 0 !important;
}

.tabs-nav li {
    padding: 7px 12px !important;
    background-color: var(--primary-color1);
    color: #fff !important;
    border-bottom: 0 !important;
    margin-right: 8px;
    border-radius: 5px;
}

.tabs-nav li.selected,
.tabs-nav li:hover {
    background-color: var(--primary-color2) !important;
}

@media print {
    .project .tab {
        display: block !important;
    }

    .project h3.mobile-only {
        color: #4A4A4A;
    }

    header,
    .tabs-nav,
    .main-header-right,
    .sidebar,
    nav,
    footer {
        display: none !important;
    }

    .project .project-contacts,
    .project .similar-projects {
        page-break-inside: avoid;
    }
}

@media screen and (max-width: 480px) {
  .similar-projects {
      display: none;
  }
}
</style>

